'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';

var getReportList = function (url, tokenAccess) { return __awaiter(void 0, void 0, void 0, function () {
    var headerData, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                headerData = {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer ".concat(tokenAccess)
                };
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: headerData
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var makeReport = function (postData, url, tokenAccess) { return __awaiter(void 0, void 0, void 0, function () {
    var headerData, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                headerData = {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer ".concat(tokenAccess)
                };
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        headers: headerData,
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var reportJobService = {
    getReportList: getReportList,
    makeReport: makeReport
};

export { reportJobService };
//# sourceMappingURL=services.js.map
